export default {
  props: {
    restrictionPreamble: {
      type: String,
    },
    restrictions: {
      type: Array,
      default: () => [],
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-ownership-conflict-modal/market-ownership-conflict-modal.js